/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "We are happy to announce the availability of Delta Lake 0.3.0! Features include: Scala Java APIs for DML commands, Scala/Java APIs for query commit history, and Scala/Java APIs for vacuuming old files."), "\n", React.createElement(_components.p, null, "Visit the ", React.createElement(_components.a, {
    href: "https://github.com/delta-io/delta/releases"
  }, "release notes"), " to learn more about the release."));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
